import React, { Component } from "react";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Store from "store";
import Link from "next/link";

import urls from "services/api/urls";
import { SocketListner } from "services/api/socket";

import { fetchNotifications, signOut } from "store/app/actions";
import { clearToken } from "store/localStorage";

import { resetSorting } from "store/posts/actions";

import { prepareURLQuery, profileImageURL } from "services/utils";

import { isMobile } from "react-device-detect";
import { parseCookies } from "nookies";

class LoggedIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: "",
      lastScrollPos: 0,
    };
    this.signout = this.signout.bind(this);
    this.socketHandler = this.socketHandler.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.refs.video && this.refs.video2) {
      this.refs.video.play();
      this.refs.video2.play();
    }
    const cookies = parseCookies();
    this.socketHandler(this.props.appData.token || cookies.token);
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  getMessageCount = (array) => {
    let count = 0;
    array.forEach(function(message) {
      count = count + message.Unread_Message_Count;
    });
    return count;
  };

  socketHandler = (token) => {
    SocketListner(token, (data) => {
      this.getRecount();
    });
  };

  getRecount = () => {
    const { fetchNotifications } = this.props;
    const cookies = parseCookies();
    fetchNotifications(cookies.token);
  };

  handleScroll = () => {
    const lastScrollY = window.scrollY;
    if (!isMobile) {
      if (this.state.lastScrollPos > lastScrollY) {
        this.setState(
          {
            direction: "top",
            lastScrollPos: lastScrollY,
          },
          () => {
            if (this.refs.headerRef) {
              this.refs.headerRef.style.marginTop = `0px`;
            }
          }
        );
      } else if (this.state.lastScrollPos < lastScrollY) {
        this.setState(
          {
            direction: "bottom",
            lastScrollPos: lastScrollY,
          },
          () => {
            if (this.refs.headerRef) {
              this.refs.headerRef.style.marginTop = `-${
                lastScrollY > 70 ? "70" : lastScrollY
              }px`;
            }
          }
        );
      }
    }
  };

  async signout(e) {
    e.preventDefault();
    const { appData, userSignOut } = this.props;
    const cookies = parseCookies();
    await userSignOut(cookies.token);
    clearToken();
  }

  resetFilters = () => {
    const { resetFilterSorting, urlDetails, location } = this.props;
    resetFilterSorting({
      sortBy: 0,
      jobType: "All job types",
      workType: "All work types",
      closeDate: "Closing anytime",
      salaryEstimate: "All salary estimates",
    });
  };

  render() {
    const {
      enableSearch,
      urlDetails,
      userData,
      location,
      deviceInfo,
      cookie,
      notifications,
      showMobileSearch,
      jobCount,
      keyword,
    } = this.props;
    const isUserLogged = userData && userData.isLogged && userData.user;

    const isDPVideo =
      userData.isLogged && userData.user
        ? userData.user.BasicInformation.isDPVideo
        : 0;

    const profileCSS = {
      display: "table-cell",
      textAlign: "center",
      verticalAlign: "middle",
    };

    const queryDetails = {
      keyword: keyword,
      location: location,
    };

    const queryParams = prepareURLQuery(queryDetails);

    const margin = {
      margin: 0,
    };

    let profilePicture;
    let profilePictureDropdown;
    if (isDPVideo) {
      profilePicture = (
        <video
          ref="video"
          autoPlay
          loop
          width="31"
          height="31"
          src={profileImageURL(userData.user.BasicInformation.DpUrl)}
          style={profileCSS}
          muted
        />
      );
      profilePictureDropdown = (
        <video
          ref="video2"
          autoPlay
          loop
          className="user-account-menu-profile"
          width="42"
          height="42"
          src={profileImageURL(userData.user.BasicInformation.DpUrl)}
          style={profileCSS}
          muted
        />
      );
    } else {
      profilePicture = userData.user.BasicInformation.DpUrl ? (
        <img
          src={profileImageURL(userData.user.BasicInformation.DpUrl)}
          alt="profile pic"
        />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31"
          height="31"
          viewBox="0 0 166 166"
        >
          <defs>
            <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="108.151%">
              <stop offset="0%" stopColor="#FFF" stopOpacity=".12" />
              <stop offset="100%" stopOpacity=".5" />
            </linearGradient>
            <circle id="a" cx="83" cy="83" r="83" />
          </defs>
          <g fill="none" fillRule="evenodd">
            <mask id="c" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <g fillRule="nonzero">
              <use fill="#000" fillOpacity=".12" xlinkHref="#a" />
              <use fill="url(#b)" fillOpacity=".4" xlinkHref="#a" />
            </g>
            <g fill="#EEE" fillRule="nonzero" mask="url(#c)">
              <g transform="translate(15.09 36.218)">
                <circle cx="67.909" cy="25.655" r="25.655" />
                <path d="M69.418 63.382C31.08 63.382 0 94.462 0 132.8h138.836c0-38.339-31.08-69.418-69.418-69.418z" />
              </g>
            </g>
          </g>
        </svg>
      );

      profilePictureDropdown = userData.user.BasicInformation.DpUrl ? (
        <img
          className="user-account-menu-profile"
          src={profileImageURL(userData.user.BasicInformation.DpUrl)}
          alt="profile pic"
        />
      ) : (
        <svg
          className="user-account-menu-profile"
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="42"
          viewBox="0 0 166 166"
        >
          <defs>
            <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="108.151%">
              <stop offset="0%" stopColor="#FFF" stopOpacity=".12" />
              <stop offset="100%" stopOpacity=".5" />
            </linearGradient>
            <circle id="a" cx="83" cy="83" r="83" />
          </defs>
          <g fill="none" fillRule="evenodd">
            <mask id="c" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <g fillRule="nonzero">
              <use fill="#000" fillOpacity=".12" xlinkHref="#a" />
              <use fill="url(#b)" fillOpacity=".4" xlinkHref="#a" />
            </g>
            <g fill="#EEE" fillRule="nonzero" mask="url(#c)">
              <g transform="translate(15.09 36.218)">
                <circle cx="67.909" cy="25.655" r="25.655" />
                <path d="M69.418 63.382C31.08 63.382 0 94.462 0 132.8h138.836c0-38.339-31.08-69.418-69.418-69.418z" />
              </g>
            </g>
          </g>
        </svg>
      );
    }

    let messagesCount,
      offersCount,
      interviewsCount = 0;
    const isNotificationEmpty =
      Object.keys(notifications).length === 0 &&
      notifications.constructor === Object;
    if (!isNotificationEmpty) {
      messagesCount = this.getMessageCount(notifications.UnreadMessges);
      offersCount = notifications.UnreadOffers.length;
      interviewsCount = notifications.UnreadInterviews.length;
    }

    return (
      <div
        className="logged-in-user-navigation container-fluid"
        ref="headerRef"
      >
        <nav className="navbar navbar-expand-lg navbar-dark bg-transparent">
          <Link href={`/?${queryParams}`}>
            <a
              className="navbar-brand"
              href={`/?${queryParams}`}
              style={margin}
              onClick={this.resetFilters}
            >
              <svg
                width="115px"
                height="29px"
                viewBox="0 0 115 29"
                version="1.1"
              >
                <g
                  id="Page-1"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="unnanu"
                    transform="translate(-8.000000, -15.000000)"
                    fill="#FFFFFF"
                  >
                    <g
                      id="unnanu-logo"
                      transform="translate(8.000000, 15.000000)"
                    >
                      <path
                        d="M114.981781,18.3766675 C114.961427,18.4146979 114.928802,18.4508865 114.922655,18.4910696 C114.849775,18.968243 114.559931,19.2849953 114.163554,19.5216686 C113.527921,19.9012068 112.852129,20.1865781 112.14352,20.4022749 C111.005838,20.7486143 109.840985,20.8043922 108.665703,20.7477771 C107.619629,20.6974048 106.652533,20.3894306 105.791755,19.7871636 C104.937053,19.1891301 104.395515,18.3665022 104.117247,17.3654425 C103.976463,16.8590407 103.895092,16.3431193 103.890452,15.8180371 C103.876364,14.2196854 103.864453,12.6212859 103.860387,11.0228624 C103.858497,10.2797634 103.876436,9.53659266 103.885836,8.79346974 C103.888826,8.55732269 103.907554,8.32576799 103.988064,8.09832727 C104.197111,7.50785202 104.873932,7.25833455 105.346728,7.37766379 C105.94579,7.52885243 106.291436,7.90430064 106.344798,8.5162786 C106.366516,8.76529378 106.380795,9.01581583 106.381274,9.26569208 C106.385101,11.3657815 106.384264,13.4658949 106.386368,15.5659843 C106.386895,16.0982181 106.499072,16.603711 106.767103,17.06871 C107.155347,17.7423497 107.746803,18.1411902 108.495427,18.2986694 C109.567046,18.5241249 110.605012,18.3816426 111.607244,17.9543391 C111.776324,17.8822489 111.941218,17.7995388 112.10482,17.7154654 C112.337164,17.5960883 112.436139,17.4072281 112.435565,17.1408241 C112.431259,15.1880964 112.434967,13.2353926 112.435995,11.2826648 C112.436378,10.5752522 112.432718,9.86783954 112.438435,9.16047473 C112.440444,8.91057456 112.445156,8.65780418 112.483378,8.41173097 C112.552311,7.96804337 112.790682,7.64318272 113.212484,7.45649906 C114.054367,7.08389715 114.921196,7.76531042 114.920263,8.59408538 C114.918684,9.93517003 114.922631,11.2762786 114.923851,12.6173632 C114.925262,14.1647208 114.924975,15.7120783 114.929663,17.2594358 C114.930046,17.3813004 114.963627,17.5030694 114.981781,17.6248622 L114.981781,18.3766675 Z"
                        id="Fill-4"
                      />
                      <path
                        d="M8.4953619,10.7638206 C8.46209131,5.77277756 12.5427017,1.71051258 17.5798118,1.75189153 C22.4656614,1.79205064 26.5558871,5.80686138 26.5205834,10.8406467 C26.4860212,15.773233 22.4074917,19.8561157 17.4354638,19.8255719 C12.4832404,19.7951236 8.43869904,15.6918624 8.4953619,10.7638206"
                        id="Fill-7"
                      />
                      <path
                        d="M18.7317444,28.0575292 C18.7317444,27.928226 18.731577,27.8198275 18.7317683,27.7114051 C18.7327968,27.1006948 18.7413835,26.4898649 18.7332752,25.8792981 C18.7206701,24.9290413 18.6865624,23.9784974 18.9038139,23.0422089 C18.9938669,22.6541557 19.1328571,22.2965267 19.461162,22.0399294 C19.6680807,21.8781927 19.9013336,21.7700095 20.1483875,21.6943314 C20.7256119,21.5175261 21.3051086,21.3479681 21.8847727,21.1792472 C22.8080017,20.9105471 23.7013565,20.577889 24.5029361,20.0293668 C25.7824068,19.1537834 26.7331421,18.0112699 27.3640156,16.5936461 C27.8620938,15.4744292 28.1873371,14.3086669 28.3506285,13.0981771 C28.4105204,12.6541546 28.4316882,12.2041765 28.4542673,11.7560879 C28.4750046,11.3444749 28.481917,10.9317139 28.4806733,10.519503 C28.4782575,9.71651217 28.4562764,8.9134974 28.4596489,8.11055439 C28.4662743,6.54109619 28.4598163,4.97092045 28.5074619,3.40251466 C28.5372644,2.42190526 28.8939605,1.54864195 29.6206514,0.855197691 C30.0631192,0.432941036 30.5976013,0.218320611 31.196735,0.122024854 C31.5688347,0.0622286814 31.9312473,0.0906199043 32.2945449,0.149148399 C33.159676,0.288545237 33.7571354,0.804490537 34.1915426,1.53414736 C34.5067163,2.06346308 34.6621385,2.64501674 34.6982554,3.25625322 C34.7277469,3.7559818 34.7447768,4.25676279 34.7539376,4.75732851 C34.7695803,5.61172015 34.7849599,6.46635098 34.7816352,7.32081437 C34.7778322,8.30797743 34.7559228,9.29509266 34.7373382,10.28216 C34.7282013,10.7682073 34.7206909,11.2547807 34.6913191,11.7397994 C34.6463523,12.4816786 34.5900243,13.2230554 34.5260185,13.9635473 C34.4294836,15.0805637 34.2306733,16.1808133 33.9470959,17.2652767 C33.4349775,19.2235536 32.572621,21.0088281 31.2884863,22.5798171 C30.5570595,23.4746309 29.7148663,24.2535598 28.7671687,24.9175604 C27.5416102,25.7762335 26.2368338,26.4809672 24.8183012,26.9678516 C23.9731181,27.2579587 23.1087047,27.4698764 22.2247498,27.5963572 C21.1539438,27.7495789 20.0815593,27.8916068 19.009677,28.0371507 C18.924001,28.0487751 18.8369378,28.0500906 18.7317444,28.0575292"
                        id="Fill-9"
                      />
                      <path
                        d="M16.1622143,28.0666852 C15.7939656,28.0216467 15.458509,27.9830902 15.1237462,27.9391759 C14.4962212,27.8568724 13.8695334,27.7682066 13.2417453,27.6879123 C11.3005702,27.4395908 9.45667149,26.8901118 7.74198035,25.9314117 C6.83269582,25.4230486 5.96545996,24.8542195 5.16997951,24.1799579 C4.17822411,23.3393672 3.34765526,22.3596428 2.65311075,21.261809 C1.65889174,19.6902699 1.03818355,17.9737131 0.688734713,16.1566509 C0.554073731,15.4564138 0.459308756,14.74759 0.370690828,14.0396511 C0.242559588,13.0158928 0.202663582,11.985509 0.184389871,10.9542882 C0.173435212,10.335637 0.147651102,9.71720102 0.141169197,9.09852589 C0.126531094,7.70606437 0.0990966098,6.31319624 0.11847057,4.92109349 C0.128181468,4.2237266 0.116772359,3.52136075 0.238086834,2.82770123 C0.390830179,1.95443792 0.761781718,1.20569416 1.46132519,0.642318532 C1.83851945,0.338553973 2.27854752,0.192794821 2.75662989,0.122618032 C3.21127215,0.0558855033 3.65311803,0.0897540557 4.09073035,0.204275686 C4.88410597,0.411887999 5.45621183,0.907909214 5.86064923,1.60692648 C6.2426511,2.26719582 6.40020206,2.98561096 6.40005855,3.74483101 C6.39953234,6.19183392 6.40048908,8.63883683 6.40498575,11.0858397 C6.40787989,12.651184 6.62489216,14.1828749 7.15100281,15.6633564 C7.52879503,16.7264845 8.02199386,17.7265635 8.76726945,18.5861933 C9.66287261,19.619232 10.733559,20.4095939 12.0310402,20.8583522 C12.761008,21.1108356 13.5095365,21.3094785 14.2488803,21.5350775 C14.6007449,21.6424475 14.9570823,21.7393412 15.2747674,21.9354248 C15.5611193,22.1121584 15.7682054,22.3532566 15.8750492,22.6744816 C16.0128196,23.0887734 16.1012701,23.5149288 16.1214573,23.9501971 C16.14705,24.5016852 16.1601095,25.0542019 16.1609227,25.6063119 C16.1616642,26.0848726 16.1313595,26.5634094 16.127413,27.0420897 C16.1253081,27.299285 16.1504943,27.5566478 16.161736,27.8140344 C16.1648693,27.8861008 16.1622143,27.9584302 16.1622143,28.0666852"
                        id="Fill-11"
                      />
                      <path
                        d="M49.6876707,13.645867 C49.6876707,15.1712195 49.6812844,16.6966438 49.6911149,18.2219485 C49.6945592,18.7580332 49.4896736,19.1490523 49.0321372,19.4348541 C48.0049346,20.076491 46.8982988,20.4875777 45.7000074,20.6650049 C44.9006521,20.7833774 44.098044,20.7894048 43.2968709,20.7401806 C42.441403,20.6876318 41.6277923,20.454331 40.8849086,20.0164556 C39.7261544,19.3334876 39.035413,18.312743 38.7589155,17.0055509 C38.6367399,16.4278959 38.5828755,15.8421565 38.5833061,15.2511072 C38.5848608,13.150946 38.5809381,11.0507848 38.5882333,8.95067149 C38.5890704,8.71043438 38.6195665,8.46249553 38.6846486,8.23177797 C38.8575791,7.61858018 39.2340558,7.39228754 39.7466765,7.35284599 C40.3473888,7.3066355 40.9365246,7.68146183 41.0641536,8.35390568 C41.0955107,8.51913446 41.106561,8.69043854 41.106872,8.85896807 C41.1108903,11.040189 41.110986,13.2213859 41.1127798,15.4025829 C41.1131625,15.8632287 41.1821912,16.3119631 41.3528017,16.7424955 C41.6930658,17.6011447 42.3336981,18.1090294 43.2220779,18.2983202 C44.2773129,18.5231538 45.3022911,18.3835178 46.2942618,17.9747033 C46.4642981,17.9046461 46.6290007,17.8215294 46.7956168,17.7432443 C47.0576436,17.6201359 47.1653006,17.4185032 47.1647027,17.1244496 C47.1594167,14.4347938 47.1616411,11.7451141 47.1651811,9.0554583 C47.1654442,8.84260784 47.1775708,8.62762864 47.2089997,8.41733746 C47.3037886,7.78333059 47.8516172,7.30749657 48.4760088,7.35358746 C49.1206594,7.40116129 49.5543013,7.78096267 49.6421538,8.47524407 C49.673487,8.72291982 49.684059,8.97461387 49.6846808,9.22449012 C49.6884839,10.6982744 49.6865465,12.1720827 49.6865465,13.645867 L49.6876707,13.645867 Z"
                        id="Fill-13"
                      />
                      <path
                        d="M86.2966865,16.0191101 C86.2966865,14.9432335 86.3058951,13.8672133 86.2911613,12.7915519 C86.2866407,12.4631513 86.2482994,12.1278144 86.1699903,11.8092921 C85.9646264,10.9738917 85.4486571,10.3919554 84.6484169,10.0668316 C83.6342499,9.65481208 82.646752,9.70927444 81.6982172,10.2571748 C80.994201,10.6638366 80.6184419,11.3039427 80.4757443,12.0882771 C80.4377857,12.2969179 80.4304188,12.512519 80.4247501,12.7253456 C80.4164504,13.0346353 80.4236259,13.3443077 80.4221669,13.6537888 C80.4131257,15.5472705 80.4050174,17.4407761 80.3918622,19.3342339 C80.3905467,19.5243618 80.3793289,19.7194169 80.3355103,19.9033499 C80.2033129,20.4580432 79.7133431,20.8213886 79.1403283,20.8351417 C78.7293612,20.8449722 78.3923978,20.7102156 78.1223583,20.4008063 C77.9037913,20.1503799 77.8630581,19.8426688 77.8536103,19.5323745 C77.8380873,19.0242984 77.8399768,18.5156482 77.836987,18.0072372 C77.8272522,16.3495438 77.8054864,14.6918025 77.8154365,13.0342526 C77.8200766,12.2621166 77.8653304,11.4879236 78.108366,10.7422175 C78.5487289,9.39106312 79.4317988,8.45183267 80.7405457,7.90902693 C81.6978345,7.51200426 82.702769,7.39126383 83.7277711,7.43426924 C84.5797709,7.47002735 85.407326,7.63683475 86.1876661,7.99943875 C87.5851744,8.64880127 88.4173697,9.74254503 88.736753,11.238717 C88.8291979,11.6717609 88.876102,12.1105213 88.8818903,12.5539219 C88.8899747,13.1725492 88.9132235,13.7911526 88.9115492,14.4097081 C88.9072439,16.0371207 88.894878,17.6645334 88.880216,19.2919221 C88.8783743,19.4968556 88.8659127,19.7066684 88.8200371,19.9053591 C88.6676286,20.5655567 88.1871783,20.8660444 87.5059325,20.8170594 C86.9852992,20.779627 86.5909075,20.5292245 86.405659,20.0284435 C86.3333774,19.8330536 86.3052732,19.6114968 86.3035032,19.4014687 C86.2939119,18.2740717 86.2989587,17.1465789 86.2989587,16.0191101 L86.2966865,16.0191101 Z"
                        id="Fill-15"
                      />
                      <path
                        d="M90.7634845,14.6387777 C90.7634845,13.1503552 90.7634845,11.6619089 90.7635323,10.1734865 C90.7635323,10.0555923 90.7668092,9.93762646 90.763939,9.81980408 C90.7537975,9.40077641 90.932325,9.0865834 91.2762008,8.85134526 C91.8208004,8.47879118 92.4045546,8.18404389 93.0227753,7.95849272 C93.8235656,7.66632862 94.6502597,7.49586169 95.5033597,7.46340433 C95.8857921,7.4488619 96.2687507,7.42403453 96.6509439,7.43135358 C97.5052638,7.44776165 98.3348042,7.59739559 99.1175122,7.95605304 C100.220871,8.46161772 101.000087,9.2753958 101.440067,10.4095139 C101.649426,10.9491385 101.778585,11.5057931 101.796357,12.0862225 C101.806713,12.4245971 101.827546,12.7629239 101.827929,13.1012985 C101.830249,15.1128896 101.82946,17.1245046 101.825202,19.1360957 C101.8247,19.3711903 101.816257,19.6094422 101.77794,19.840662 C101.665642,20.518655 101.169956,20.8620524 100.499928,20.8175162 C100.390621,20.8102689 100.279711,20.7899861 100.175043,20.7578157 C99.6779937,20.604881 99.3748271,20.1887236 99.3464837,19.6244869 C99.3387341,19.4700932 99.3417957,19.3150776 99.3415565,19.1603729 C99.3384949,17.1266572 99.340528,15.0929416 99.3284491,13.0592737 C99.3262247,12.6856433 99.3045307,12.3043351 99.2270348,11.9403677 C98.9813204,10.7862059 98.2369298,10.1143122 97.0999415,9.87323794 C96.1246898,9.66646277 95.1815367,9.83999126 94.2612258,10.1752564 C94.0474664,10.253135 93.8420785,10.3558648 93.6375278,10.4566812 C93.3717936,10.5877065 93.2544017,10.7973041 93.2804489,11.1028864 C93.2991293,11.3213817 93.2676526,11.5436799 93.2674134,11.7643039 C93.2645432,14.1959033 93.2649019,16.6275027 93.259616,19.0591021 C93.2590897,19.3083565 93.2450257,19.560218 93.2072345,19.8062673 C93.1156268,20.4030809 92.6411322,20.8503563 91.9603169,20.8206974 C91.275555,20.790871 90.806753,20.3099663 90.7681964,19.6345566 C90.7635802,19.5537361 90.765398,19.4725089 90.765398,19.3914493 C90.7652545,17.8072334 90.7652784,16.2229936 90.7652784,14.6387777 L90.7634845,14.6387777 Z"
                        id="Fill-17"
                      />
                      <path
                        d="M51.4515166,14.615548 C51.4515166,13.0237022 51.4553914,11.4318324 51.4490052,9.8400104 C51.4472592,9.40158486 51.6263606,9.06811356 51.9820522,8.8333777 C52.5682221,8.4465443 53.1909873,8.13235129 53.8598434,7.90849834 C55.0059208,7.52494176 56.1835705,7.37078723 57.3859041,7.43469738 C58.091188,7.47217762 58.7951564,7.54675541 59.4642038,7.80887791 C60.5018349,8.2153723 61.3322841,8.86387375 61.8724349,9.85275894 C62.2124599,10.4753328 62.4065822,11.1466525 62.4663783,11.8505012 C62.5062265,12.3194228 62.5145023,12.7920279 62.5154351,13.2630304 C62.5193577,15.2528317 62.5165354,17.242657 62.5120865,19.2324584 C62.5116082,19.4379659 62.4997685,19.6460805 62.4657086,19.848359 C62.3562577,20.4986543 61.8739896,20.866927 61.1807606,20.8169135 C61.0714532,20.8090204 60.9605911,20.788905 60.8559478,20.7565193 C60.3556452,20.6015755 60.0657533,20.1920196 60.0321718,19.596067 C60.0234655,19.4416972 60.0267423,19.2866337 60.0264074,19.1318812 C60.0220782,17.1420559 60.0227958,15.1522307 60.0101668,13.162501 C60.0075836,12.7515817 59.9967007,12.3330324 59.9187026,11.9317762 C59.704728,10.8308091 58.8867881,10.0760379 57.7613284,9.8672057 C56.7731369,9.6838228 55.8265395,9.83343282 54.903478,10.194506 C54.7117236,10.2695144 54.5281493,10.3652361 54.3400306,10.4496683 C54.0676231,10.5719156 53.9440842,10.7793844 53.9464043,11.0794176 C53.9517621,11.7721204 53.9462608,12.464895 53.9456629,13.1576456 C53.9439168,15.1327132 53.9442756,17.1077808 53.9386069,19.0828245 C53.9378415,19.34698 53.9332731,19.6159193 53.8849578,19.8741192 C53.7749807,20.4619395 53.2780984,20.8603973 52.6066352,20.8171048 C51.9280921,20.7733579 51.4923694,20.3157498 51.45465,19.5237136 C51.4507991,19.4427974 51.4526647,19.3615942 51.4526647,19.2805584 C51.4525691,17.725547 51.452593,16.1705356 51.452593,14.615548 L51.4515166,14.615548 Z"
                        id="Fill-19"
                      />
                      <path
                        d="M64.5705411,14.6696779 C64.5705411,13.055564 64.5770947,11.4414021 64.5663075,9.827336 C64.5632699,9.37489424 64.7475617,9.05216233 65.1154038,8.81252319 C66.1241413,8.15538717 67.2229797,7.73856 68.4124452,7.55032165 C69.1216039,7.43807228 69.8338002,7.40293604 70.5490103,7.43106416 C71.5482522,7.47033829 72.503508,7.67409973 73.3750014,8.19748367 C74.3560174,8.78664341 74.9960517,9.63589257 75.3409321,10.7178206 C75.5143649,11.2618462 75.6076709,11.8199837 75.6086994,12.3909415 C75.6120001,14.2335246 75.61145,16.0761078 75.6114978,17.918691 C75.6115217,18.4419793 75.6103258,18.9652915 75.6054704,19.4885558 C75.6044658,19.5982938 75.5931524,19.7093951 75.5727499,19.8172674 C75.4487805,20.4732075 75.0862722,20.8084009 74.42507,20.8223932 C73.8201719,20.8351896 73.3484279,20.5610122 73.1856149,19.9088512 C73.1293108,19.6834914 73.12546,19.4410777 73.1247902,19.2063657 C73.1190259,17.1942484 73.1231638,15.1821072 73.1149119,13.1700138 C73.1134051,12.7955941 73.1041725,12.4152665 73.0391621,12.0481898 C72.8269575,10.8507116 72.0393223,10.0885735 70.8457667,9.86723201 C69.8252613,9.67798908 68.8535735,9.85197203 67.9072871,10.236294 C67.7504776,10.299965 67.599002,10.3767432 67.4446322,10.4464895 C67.179472,10.566321 67.069184,10.7683125 67.0696384,11.0613855 C67.0729631,13.2356461 67.0713605,15.4099306 67.064783,17.5841912 C67.062726,18.2618732 67.046892,18.9396987 67.0252218,19.6170698 C67.0142672,19.9591756 66.9009175,20.2714073 66.6381492,20.5048038 C66.2466039,20.8526501 65.7885413,20.9045531 65.316008,20.7249494 C64.862179,20.5524494 64.6233291,20.1942703 64.581113,19.7107584 C64.5696083,19.5789198 64.5721675,19.44567 64.5721197,19.3130421 C64.5715696,17.7652541 64.5717848,16.217466 64.5717848,14.6696779 L64.5705411,14.6696779 Z"
                        id="Fill-21"
                      />
                      <path
                        d="M84.5954399,15.1427685 C84.6432051,15.8139686 84.0350302,16.395881 83.3606968,16.3892078 C82.6257779,16.3819605 82.1009827,15.7776364 82.0989497,15.1464759 C82.096797,14.4775241 82.6858132,13.8854703 83.3574199,13.8877186 C84.0424449,13.8900387 84.6345705,14.4629578 84.5954399,15.1427685"
                        id="Fill-23"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </a>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#mobileMenu"
            aria-controls="mobileMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse">
            <ul className="navbar-nav user-navbar-nav mx-auto">
              <li className="nav-item nav-item-profile">
                <a
                  className="nav-link"
                  href={`${urls.Recruit}/dashboard?service=findjobs`}
                >
                  <svg width="20" height="15" viewBox="0 0 20 15">
                    <g fill="#FFF" fillRule="evenodd">
                      <path d="M4.808 5.735C4.789 3.075 7.098.911 9.949.933c2.766.022 5.08 2.161 5.06 4.843-.02 2.628-2.327 4.804-5.141 4.787-2.803-.016-5.092-2.202-5.06-4.828" />
                      <path d="M10.601 14.95v-.185c0-.325.006-.65.001-.976-.007-.506-.026-1.013.097-1.512.05-.206.13-.397.315-.534.117-.086.25-.143.39-.184.326-.094.654-.184.982-.274.522-.143 1.028-.32 1.482-.613a4.357 4.357 0 0 0 1.619-1.83 6.484 6.484 0 0 0 .558-1.863c.034-.237.046-.476.059-.715.012-.22.015-.44.015-.659-.002-.428-.014-.856-.012-1.284.004-.836 0-1.672.027-2.508.017-.523.219-.988.63-1.357.25-.225.553-.34.892-.391a2.05 2.05 0 0 1 .621.014c.49.075.828.35 1.074.738.178.282.266.592.287.918.016.266.026.533.031.8.009.455.018.91.016 1.366-.002.526-.015 1.052-.025 1.578-.005.259-.01.518-.026.776-.026.396-.058.79-.094 1.185a9.973 9.973 0 0 1-.327 1.76 7.191 7.191 0 0 1-1.505 2.831 6.94 6.94 0 0 1-1.427 1.246 9.172 9.172 0 0 1-2.235 1.092 8.423 8.423 0 0 1-1.468.335c-.606.082-1.213.157-1.82.235-.048.006-.097.007-.157.01M9.147 14.955c-.208-.024-.398-.045-.588-.068-.355-.044-.71-.092-1.065-.134-1.098-.133-2.142-.425-3.112-.936a9.149 9.149 0 0 1-1.456-.933 6.883 6.883 0 0 1-1.424-1.555C.939 10.49.588 9.577.39 8.609a14.53 14.53 0 0 1-.285-2.772c-.007-.33-.021-.66-.025-.99C.072 4.107.056 3.365.067 2.623c.006-.372 0-.746.068-1.115C.22 1.04.43.642.827.342c.214-.162.463-.24.733-.277.257-.035.507-.017.755.044.45.11.773.375 1.002.747.216.352.305.735.305 1.14 0 1.303 0 2.607.003 3.91.002.835.124 1.65.422 2.44.214.566.493 1.1.915 1.557.507.55 1.113.972 1.847 1.21.413.135.837.241 1.255.361.2.058.401.11.58.214.163.094.28.222.34.393.079.221.129.448.14.68.014.294.022.588.022.883 0 .255-.016.51-.019.765 0 .137.013.274.02.41.002.04 0 .078 0 .136" />
                    </g>
                  </svg>
                  My Unnanu
                </a>
              </li>
              <li className="nav-item nav-item-messages">
                <a className="nav-link" href={`${urls.Recruit}/message`}>
                  <svg width="17" height="16" viewBox="0 0 17 16">
                    <g fill="#FFF" fillRule="nonzero">
                      <path d="M17 0h-5.667v12H17V0zm-5.667 0H0v12h2.267v4l5.288-4h3.778V0zm4.534 10.857h-8.5L3.4 13.714v-2.857H1.133V1.143h14.734v9.714z" />
                      <path d="M3.4 5.143h5.667a.569.569 0 0 0 .566-.572A.569.569 0 0 0 9.067 4H3.4a.569.569 0 0 0-.567.571c0 .316.254.572.567.572zM2.833 7.429c0 .316.196.571.436.571h10.462c.24 0 .436-.255.436-.571 0-.316-.196-.572-.436-.572H3.269c-.24 0-.436.256-.436.572z" />
                    </g>
                  </svg>
                  Messages
                </a>
                {messagesCount > 0 && (
                  <span className="notifications">{messagesCount}</span>
                )}
              </li>
              <li className="nav-item nav-item-interviews">
                <a className="nav-link" href={`${urls.Recruit}/interviews`}>
                  <svg width="17" height="16" viewBox="0 0 17 16">
                    <g fill="#FFF" fillRule="nonzero">
                      <path d="M8.35 8.968a4.486 4.486 0 0 0 4.485-4.485A4.474 4.474 0 0 0 8.351.013c-2.477 0-4.485 2.008-4.485 4.47A4.494 4.494 0 0 0 8.35 8.968zm0-7.786a3.311 3.311 0 0 1 3.302 3.301 3.311 3.311 0 0 1-3.301 3.302 3.311 3.311 0 0 1-3.302-3.302A3.311 3.311 0 0 1 8.35 1.182zM.592 15.97h15.573c.33 0 .591-.26.591-.59a5.633 5.633 0 0 0-5.626-5.628H5.627A5.633 5.633 0 0 0 0 15.38c0 .33.261.592.592.592zm5.035-5.034h5.503a4.44 4.44 0 0 1 4.402 3.852H1.224a4.452 4.452 0 0 1 4.403-3.852z" />
                    </g>
                  </svg>
                  Interviews
                </a>
                {interviewsCount > 0 && (
                  <span className="notifications">{interviewsCount}</span>
                )}
              </li>
              <li className="nav-item nav-item-offers">
                <a className="nav-link" href={`${urls.Recruit}/offers`}>
                  <svg width="19" height="16" viewBox="0 0 19 16">
                    <path
                      fill="#FFF"
                      fillRule="nonzero"
                      d="M18.369 2.803a1.33 1.33 0 0 0-.986-.413h-4.05V.66a.631.631 0 0 0-.63-.642H6.067a.64.64 0 0 0-.642.642v1.73H1.387c-.39 0-.72.14-.986.413-.26.266-.401.596-.401.974v10.258c0 .379.134.714.401.986.26.267.596.401.986.401h15.996c.39 0 .725-.134.986-.4a1.37 1.37 0 0 0 .4-.987V3.777c0-.378-.14-.708-.4-.974zM6.697 1.29h5.375v1.1H6.697v-1.1zm10.8 12.745c0 .08-.034.115-.114.115H1.387c-.058 0-.126-.069-.126-.115V8.281h6.49v.31c0 .355.276.63.631.63h1.994a.631.631 0 0 0 .642-.63v-.31h6.48v5.754zM1.262 7.02V3.777c0-.08.045-.115.126-.115h15.996c.08 0 .115.035.115.115V7.02H1.26z"
                    />
                  </svg>
                  Offers
                </a>
                {offersCount > 0 && (
                  <span className="notifications">{offersCount}</span>
                )}
              </li>
              <li
                className={`nav-item nav-item-find-jobs ${urlDetails !==
                  undefined &&
                  urlDetails.pathname === "/" &&
                  "active"}`}
              >
                <a className="nav-link" href="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 24 24"
                    stroke={`${
                      urlDetails !== undefined && urlDetails.pathname === "/"
                        ? "#ffc107"
                        : "#000"
                    }`}
                  >
                    <path
                      fill={`${
                        urlDetails !== undefined && urlDetails.pathname === "/"
                          ? "#ffc107"
                          : "#000"
                      }`}
                      fillRule="nonzero"
                      d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
                    />
                    <path
                      fill={`${
                        urlDetails !== undefined && urlDetails.pathname === "/"
                          ? "#ffc107"
                          : "#000"
                      }`}
                      fillRule="nonzero"
                      d="M20 3v4"
                    />
                    <path
                      fill={`${
                        urlDetails !== undefined && urlDetails.pathname === "/"
                          ? "#ffc107"
                          : "#000"
                      }`}
                      fillRule="nonzero"
                      d="M22 5h-4"
                    />
                    <path
                      fill={`${
                        urlDetails !== undefined && urlDetails.pathname === "/"
                          ? "#ffc107"
                          : "#000"
                      }`}
                      fillRule="nonzero"
                      d="M4 17v2"
                    />
                    <path
                      fill={`${
                        urlDetails !== undefined && urlDetails.pathname === "/"
                          ? "#ffc107"
                          : "#000"
                      }`}
                      fillRule="nonzero"
                      d="M5 18H3"
                    />
                  </svg>
                  Jobs for{" "}
                  {userData.user.BasicInformation.FullName.split(" ")[0]}
                </a>
              </li>
              {/*<li className={`nav-item nav-item-find-jobs ${urlDetails.pathname === '/match' ? 'active' : ''}`}>*/}
              {/*  <a className="nav-link" href={`${urls.BaseURL}/match`}>*/}
              {/*    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 24 24"*/}
              {/*         stroke={`${urlDetails.pathname === '/match' ? "#266ADC" : "#FFFFFF"}`}*/}
              {/*    >*/}
              {/*      <path fill={`${urlDetails.pathname === '/match' ? "#266ADC" : "#FFFFFF"}`} fillRule="nonzero"*/}
              {/*            d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>*/}
              {/*      <path fill={`${urlDetails.pathname === '/match' ? "#266ADC" : "#FFFFFF"}`} fillRule="nonzero"*/}
              {/*            d="M20 3v4"/>*/}
              {/*      <path fill={`${urlDetails.pathname === '/match' ? "#266ADC" : "#FFFFFF"}`} fillRule="nonzero"*/}
              {/*            d="M22 5h-4"/>*/}
              {/*      <path fill={`${urlDetails.pathname === '/match' ? "#266ADC" : "#FFFFFF"}`} fillRule="nonzero" d="M4 17v2" />*/}
              {/*      <path fill={`${urlDetails.pathname === '/match' ? "#266ADC" : "#FFFFFF"}`} fillRule="nonzero" d="M5 18H3" />*/}
              {/*    </svg>*/}
              {/*    Jobs for you*/}
              {/*  </a>*/}
              {/*</li>*/}
            </ul>
            <div className="navbar-nav user-menu-right d-flex my-2 my-lg-0">
              <div
                className="user-account-menu-name"
                style={{ color: "lightyellow" }}
              >
                Hello,
                <br />
                {userData.user.BasicInformation.FullName.split(" ")[0]}!
              </div>
              <div className="user-profile ml-auto btn-group">
                <button
                  className="profile-button btn dropdown-toggle"
                  type="button"
                  id="dropdownMenu2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {profilePicture}
                </button>
                <div
                  className="user-account-menu dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenu2"
                >
                  <div className="user-account-menu-header">
                    {profilePictureDropdown}
                    <div className="user-account-menu-name">
                      Hello,
                      <br />
                      {userData.user.BasicInformation.FullName.split(" ")[0]}!
                    </div>
                  </div>
                  {/* <Link  href={`https://unnanu.com/profilePro`} ><a className="dropdown-item unnanu-pro" href="https://unnanu.com/profilePro">Upgrade to PRO</a></Link> */}
                  <Link href={`${urls.Recruit}/more`}>
                    <a className="dropdown-item">Account</a>
                  </Link>
                  <Link href={`${urls.Recruit}/more/aboutme`}>
                    <a className="dropdown-item">About Me</a>
                  </Link>
                  <Link href={`${urls.Recruit}/more/referrals`}>
                    <a className="dropdown-item">Referrals</a>
                  </Link>
                  <Link href={`${urls.Recruit}/more/feedback`}>
                    <a className="dropdown-item">Feedback</a>
                  </Link>
                  <hr className="user-account-menu-hr" />
                  <Link href="#">
                    <a
                      onClick={(e) => this.signout(e)}
                      className="dropdown-item"
                      href="#"
                    >
                      Sign out
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { app, posts } = state;

  return {
    appData: app,
    location: app.location,
    jobCount: posts.count,
    notifications: app.notifications,
    showMobileSearch: app.showMobileSearch,
    keyword: posts.facets.keyword,
  };
};

const mapDispatchToProps = (dispatch) => ({
  userSignOut: (data) => dispatch(signOut(data)),
  resetFilterSorting: (data) => dispatch(resetSorting(data)),
  fetchNotifications: (token) => dispatch(fetchNotifications(token)),
});

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(LoggedIn)
);



// WEBPACK FOOTER //
// ./components/Header/loggedIn.js